import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const makeIcon = (color) => new L.DivIcon({
  className: 'fuel-marker',
  html: `<div style="background:${color};width:26px;height:26px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,.3)"></div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 26],
});

const icons = { full: makeIcon('#16a34a'), partial: makeIcon('#f59e0b'), none: makeIcon('#dc2626') };

const LUANDA = [-8.8383, 13.2344];

export const FuelStationsMap = ({ stations, userPos }) => {
  const located = stations.filter(s => s.latitude && s.longitude);
  const center = userPos ? [userPos.lat, userPos.lng] : located[0] ? [located[0].latitude, located[0].longitude] : LUANDA;

  return (
    <div className="relative isolate z-0 h-56 rounded-2xl overflow-hidden border border-zinc-200 shadow-sm" data-testid="fuel-stations-map">
      <MapContainer center={center} zoom={12} style={{ height: '100%', width: '100%' }} scrollWheelZoom={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        {userPos && <CircleMarker center={[userPos.lat, userPos.lng]} radius={8} pathOptions={{ color: '#2563eb', fillOpacity: 0.8 }} />}
        {located.map(s => {
          const level = s.has_gasoleo && s.has_gasolina ? 'full' : (s.has_gasoleo || s.has_gasolina) ? 'partial' : 'none';
          return (
            <Marker key={s.id} position={[s.latitude, s.longitude]} icon={icons[level]}>
              <Popup>
                <strong>{s.name}</strong><br />
                Gasóleo: {s.has_gasoleo ? 'Sim' : 'Não'} · Gasolina: {s.has_gasolina ? 'Sim' : 'Não'}
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default FuelStationsMap;
